const mutations = {
    SET_ERROR_PRODUCTS(state, payload) {
        state.error = payload;
    },
    SET_SALE_PRODUCTS(state, { data, expiredAt, tenantId }) {
        state.saleProducts = { data, tenantId, expiredAt };
    },
    SET_NO_SALE_PRODUCTS_NOTICE_SHOWN(state) {
        state.isNoSaleProductsNoticeShown = true;
    }
};

export default mutations;
